module.exports = __webpack_public_path__ + "img/lat-tilt-notice.bcf6c5fc.png";